<template>
    <modal name="judge-result-modal" class="judge-info-modal"
           :width="650"
           :height="'auto'"
           @before-open="handlerBeforeOpen"
           @before-close="handlerBeforeClose"
    >
        <div class="modal_title">심사결과</div>
        <div class="pl30 pr30 pb30">

            <div class="judge_info_content" v-if="hasData()">
                <div><span class="judge_title">등수 : </span>{{ result.ci_rank }}</div>
                <div><span class="judge_title">상금 : </span>{{ returnCommas(result.ci_prize) }}Mg</div>
                <div><span class="judge_title">심사결과 : </span><span> {{ result.ci_result }}</span></div>


            </div>
            <div class="judge_info_content" v-else>
                심사결과가 없습니다.
            </div>
            <div class="btn_box text-center mt20">
                <el-button class="reg_btn_out" @click="closeModal()">학인</el-button>
            </div>
        </div>
    </modal>
</template>

<script>
import util from "@/mixins/util";

export default {
    name: "JudgeResultModal",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            result: '',
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        handlerBeforeOpen(event) {
            this.result = event.params.result
        },
        handlerBeforeClose() {
            this.$router.replace(this.$route.path);
        },
        closeModal() {
            this.$modal.hide('judge-result-modal')
        },
        movePage() {
            this.$router.push()
        },
        hasData() {
            return !util.isEmpty(this.result)
        },
        returnCommas(x = 0) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
